import { GeneralInfoWithKycQuery, KycRejectType, KycStatus } from 'gql'

export type KycInfo = GeneralInfoWithKycQuery['kycInfo'] | null

export class Kyc {
  status: ReturnType<typeof getStatus>
  lastSyncTime?: string
  generalLink: string
  supportLink: string
  resubmitLink: string
  usInvestorsLink: string
  approved: boolean

  constructor(info: KycInfo) {
    this.status = getStatus(info)
    this.lastSyncTime = info?.lastSyncTime ?? undefined
    this.generalLink = info?.generalLink ?? ''
    this.supportLink = info?.supportLink ?? ''
    this.resubmitLink = info?.resubmitLink ?? ''
    this.usInvestorsLink = info?.usInvestorsLink ?? ''
    this.approved = info?.status === KycStatus.Approved
  }
}

function getStatus(info?: KycInfo) {
  switch (info?.status) {
    case KycStatus.Approved:
      return 'verified'
    case KycStatus.Rejected:
      switch (info?.rejectType) {
        case KycRejectType.Final:
          return 'rejectedFinal'
        case KycRejectType.Retry:
        default:
          return 'rejectedRetry'
      }
    case KycStatus.Empty:
    default:
      return 'notVerified'
  }
}
